var Component = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ReportDiscussionTab.vue"),
  /* template */
  require("!!../../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-05b4d731!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ReportDiscussionTab.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/features/courses/pages/Reports/ReportDiscussionTab.vue
// module id = 2250
// module chunks = 61